import React from 'react';

import { bemCssModules } from '@utils';

import Logo from '@components/Logo';
import Spinner from '@components/Spinner';

import style from './GlobalLoaderLayout.scss';

const cn = bemCssModules(style, 'GlobalLoaderLayout');

export type TGlobalLoaderLayout = {
  isLoading?: boolean;
  size?: number;
};

const GlobalLoaderLayout: CustomFC<TGlobalLoaderLayout> = props => {
  const { children, isLoading, size = 60 } = props;

  return isLoading ? (
    <div className={cn('loader')}>
      <Logo />
      <Spinner className={cn('preloader')} size={size} />
    </div>
  ) : (
    <>{children}</>
  );
};

export default GlobalLoaderLayout;
